
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ElectronFunctions, IElectronFileEntry } from "@/utils/electron/electron";

export default Vue.extend({
	data(){
		return {
			modalOpen: false,
			modalPath: "",
			dirContent: [] as IElectronFileEntry[]
		};
	},
	props: {
		value: {
			type: String
		},
		showRemoveButton: Boolean,
		fancy: Boolean,
		label: {
			type: [String, Object as ()=>TranslateResult]
		}
	},
	computed: {
		shownValue():string {
			if (this.value) {
				return this.value;
			}
			return "";
		},
		icon():string{
			if (this.showRemoveButton) {
				return "times";
			}
			return "";
		},
		isInRoot():boolean {
			if (!this.modalPath){
				return true;
			}
			if (this.modalPath == "/") {
				return true;
			}
			return false;
		},
		heightStyle():string | null {
			if (this.$wf.isSmDown) return null;
			return "750px";
		},
		openedPathParts():string[] {
			return this.modalPath.replaceAll("\\", "/").split("/");
		}
	},
	watch: {
		modalPath(){
			if (!this.$refs.scrollView) return;
			let el = this.$refs.scrollView as Vue;
			el.$el.scrollTop = 0;
		}
	},
	methods: {
		onInput(value:string | null) {
			this.$emit("input", value);
		},
		async openModal(){
			this.blur();
			if (this.value) {
				this.modalPath = this.value;
			}else{
				this.modalPath = await ElectronFunctions.getHomeDir();
			}
			this.openDirectory(this.modalPath);
			this.modalOpen = true;
		},
		blur(){
			if (!this.$refs.input) return;
			(this.$refs.input as any).blur();
		},
		async openDirectory(val:string){
			console.log(val);
			this.modalPath = val;
			let items = await ElectronFunctions.lsDirectory(val);
			this.dirContent = items.filter(f=>f.isDirectory);
		},
		setDirectory(){
			this.onInput(this.modalPath);
			this.modalOpen = false;
		},
		openParentDir(){
			let pathParts = this.modalPath.replaceAll("\\", "/").split("/");
			pathParts.pop();
			this.openDirectory(pathParts.join("/"));
		},
		openPathPart(i:number){
			let str = "";
			for (let c = 0; c <= i; c++){
				if (c == 0){
					str += this.openedPathParts[c];
				}else{
					str+=`/${this.openedPathParts[c]}`;
				}
			}
			this.openDirectory(str);
		}
	}
});
